import React from 'react'
import {connect} from 'react-redux'
import {withRouter} from 'react-router-dom'
import {InfoField} from '../../common/InfoField'
import classes from './styles.module.scss'
import {ContactInfo} from '../../../api/model/ContactInfo'

export const preparePhoneNumber = (phone: string): string => {
  return `(${phone.slice(0, 3)}) ${phone.slice(3, 6)}-${phone.slice(6, 10)}`
}

interface GeneralInfoSectionProps {
    contactInfo: ContactInfo
}

const GeneralInfoSection: React.FC<GeneralInfoSectionProps> = ({contactInfo}) => {

  const {
    firstAndLastName,
    username,
    email,
    phone,
    userEmail,
    userPhoneNumber,
    activationLink,
    feedbackSatisfactionQ1,
    feedbackRecommendationQ1,
    feedbackSatisfactionQ2,
    feedbackRecommendationQ2,
    feedbackSatisfactionQ3,
    feedbackRecommendationQ3
  } = contactInfo

  const getRatingLabel = (rating, labelMap) => {
    if (!rating || rating < 1 || rating > 5) return 'NONE'
    const stars = '⭐'.repeat(rating)
    const label = labelMap[rating]
    return `${stars} ${label}`
  }

  const satisfactionLabels = {
    5: 'Very Satisfied',
    4: 'Satisfied',
    3: 'Neutral',
    2: 'Dissatisfied',
    1: 'Very Dissatisfied',
  }

  const recommendationLabels = {
    5: 'Strongly Agree',
    4: 'Agree',
    3: 'Neutral',
    2: 'Disagree',
    1: 'Strongly Disagree',
  }
  return (
    <>
      <div className={classes.userName}>
        {firstAndLastName}
      </div>
      <InfoField
        title={'User name'}
        value={username}
      />
      <InfoField
        title={'Email address'}
        value={email}
      />
      <InfoField
        title={'PCP Email address'}
        value={userEmail ? userEmail : 'NONE'}
      />
      <InfoField
        title={'Phone number'}
        value={phone ? preparePhoneNumber(phone) : 'NONE'}
      />
      <InfoField
        title={'PCP Phone number'}
        value={userPhoneNumber ? preparePhoneNumber(userPhoneNumber) : 'NONE'}
      />
      <InfoField
        title={'Activation link'}
        value={activationLink ? activationLink : 'NONE'}
        link={!!activationLink }
      />
      <InfoField
        title={'Satisfaction feedback Q1'}
        value={ getRatingLabel(feedbackSatisfactionQ1, satisfactionLabels) }
      />
      <InfoField
        title={'Recommendation feedback Q1'}
        value={ getRatingLabel(feedbackRecommendationQ1, recommendationLabels) }
      />
      <InfoField
        title={'Satisfaction feedback Q2'}
        value={ getRatingLabel(feedbackSatisfactionQ2, satisfactionLabels) }
      />
      <InfoField
        title={'Recommendation feedback Q2'}
        value={ getRatingLabel(feedbackRecommendationQ2, recommendationLabels) }
      />
      <InfoField
        title={'Satisfaction feedback Q3'}
        value={ getRatingLabel(feedbackSatisfactionQ3, satisfactionLabels) }
      />
      <InfoField
        title={'Recommendation feedback Q3'}
        value={ getRatingLabel(feedbackRecommendationQ3, recommendationLabels) }
      />
    </>
  )
}

const mapStateToProps = state => ({
  contactInfo: state.contactInfo
})

export default withRouter(connect(mapStateToProps)(GeneralInfoSection))
